import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../nest-api";

@Injectable()
export class PollingProvider {

  private _service: string = 'attendance';
  private _model: string = 'polling';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getPolling(limit: string | number, page: string | number): Observable<any> {

    const _method: string = 'GET';
    const _func: string = 'getPolling';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof limit !== 'undefined' && limit !== null) _urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) _urlParams.page = page;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public getPollingDetail(params: any): Observable<any> {

    const _method: string = 'POST';
    const _func: string = 'getPollingDetail';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public addPolling(params: any): Observable<any> {

    const _method: string = 'POST';
    const _func: string = 'addPolling';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public updatePollingSFGO(params: any): Observable<any> {

    const _method: string = 'POST';
    const _func: string = 'updatePollingSFGO';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public deletePollingSFGO(params: any): Observable<any> {

    const _method: string = 'POST';
    const _func: string = 'deletePollingSFGO';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public votePollingSFGO(params: any): Observable<any> {

    const _method: string = 'POST';
    const _func: string = 'votePollingSFGO';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/polling/polling.ts